import { buildSectionUrl, getSectionInnerHTML } from './utils';
import { Modal as PDPDialog } from '../../components/Modal';
import { FindStore } from '../../components/FindStore';

function getSectionToRender() {
  return {
    id: 'pdp-find-store-modal',
    section: `pdp-find-store`,
    selector: '.shopify-section',
  };
}

const findStore = () => {
  const findStoreBtn = document.querySelector('.pdp-c-description__find-in-store-btn');

  function findStoreClickHandle() {
    const sectionToRender = getSectionToRender();
    const url = buildSectionUrl([sectionToRender]);

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Response error is not okay');
        }
        return response.json();
      })
      .then((data) => {
        const dialogObj = new PDPDialog(sectionToRender.id);
        dialogObj.setContent(getSectionInnerHTML(data[sectionToRender.section], sectionToRender.selector)).show();

        // Defer this block because they are not user-visible tasks
        setTimeout(() => {
          const findStoreInstance = new FindStore(dialogObj.node.querySelector('.pdp-c-find-store'));
          findStoreInstance.init();

          dialogObj.setClose(() => findStoreInstance.close());
        }, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  findStoreBtn?.addEventListener('click', findStoreClickHandle);
};

export default findStore;
